<ng-template #cropImageModal>
  <div class="d-flex flex-column p-5">
    <!--

        (touchstart)="cropperDragStart($event)" (touchmove)="cropperDragContinue($event)" (touchend)="cropperDragEnd()"  
           (touchstart)="cropperDragStart($event)" (touchmove)="cropperDragContinue($event)" (touchend)="cropperDragEnd()"  
    -->

    <div style="position: relative">
      <img [src]="imageToBeCropped" style="width: 100%; height: auto" id="imageToBeCropped" />
      <div (pointerdown)="cropperDragStart($event)" (pointermove)="cropperDragContinue($event)" (pointerup)="cropperDragEnd()" style="border: 3px dashed var(--secondary); position: absolute; top: 0; left: 0" id="cropper"></div>
    </div>
    <button class="mt-2 my-button-3" (click)="saveCrop()"><i class="fa-solid fa-scissors"></i> Set Crop</button>
  </div>
</ng-template>

<ng-template #companyNameSuggestionsModal>
  <div class="w-100 position-absolute shadow d-flex flex-column align-items-center p-3 rounded-sm bg-white predicted-names" *ngIf="companyNameSearchSuggestions.length" 
  (clickOutside)="companyNameSearchSuggestions = []">
    <div class="w-100 position-static m-2 bordered" style="color: black; text-transform: capitalize" 
    *ngFor="let suggestion of companyNameSearchSuggestions" 
    >{{ suggestion.companyName }}, {{ suggestion.subRegionName }}</div>
  </div>
</ng-template>

<ng-container *ngIf="!enableMemberShop">
  <!-- <a href="{{shopWebLink}}" target="_blank" class="shop_web_link"><i class="fa-solid fa-link"></i></a> -->
  <div class="shop-myvip">
    <div class="shop-myvip__header">
      @if (get_all_product_banner_length !== 0) {
        <app-add-product-crousal></app-add-product-crousal>
      } @else {
        <img loading="lazy" class="banner" src="../../../../assets/images/uploadd1.png" alt="" />
      }
      <div class="body">
        <div class="shop-img">
          <img loading="lazy" src="{{ imgUrl }}{{ shop_logo }}" alt="" />
        </div>
        <div>
          <div class="name">
            {{ shopName }}
          </div>
          <div class="about">
            {{ shop_description }}
          </div>
        </div>

        <ul class="icons">
          <li ngbTooltip="Add or Remove Banner" (click)="openAddBannerModal(addBannerModal)">
            <svg viewBox="0 0 800 515" fill="none">
              <path d="M758.902 159.515L779.382 41C751.34 57.5375 680.979 93.0077 593.274 93.0203C587.466 93.0203 581.671 92.7393 575.891 92.4178L729.668 229.888C756.229 221.766 780.744 211.667 799.568 198.983L758.902 159.515Z" fill="black" />
              <path d="M720.477 239.663L714.471 234.319L560.094 96.3242L546.994 260.454L546.549 265.999L547.556 267.181L553.028 273.571L577.961 302.727H791.022L726.444 245.018L720.477 239.663Z" fill="black" />
              <path d="M589.445 316.15H580.609H571.773H491.853H330.774H322.738H314.695H238.389H229.561H220.725H10.1855H10.1602L59.7956 514.138H60.2209H69.0568H314.158H321.665H329.169H491.853H741.114H749.937H750.382L800 316.15H799.977H589.445Z" fill="black" />
              <path d="M77.8875 232.222L235.303 91.521C225.692 92.4046 216.011 93.0223 206.289 93.0223C118.591 93.0223 48.2303 57.5598 20.1884 41.002L40.6451 159.517L0 198.982C20.6871 212.93 48.2835 223.728 77.8875 232.222Z" fill="black" />
              <path d="M256.58 274.227L262.059 267.822L263.613 265.999L263.226 261.155L259.694 216.783L250.071 96.3242L93.3413 236.41L87.2448 241.858L81.1888 247.271L19.1426 302.727H232.201L256.58 274.227Z" fill="black" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M319.416 152.179L305.504 189.279C304.969 190.707 304.857 192.258 305.181 193.748C305.505 195.238 306.25 196.603 307.329 197.68C308.407 198.757 309.773 199.501 311.263 199.824C312.753 200.146 314.304 200.032 315.731 199.496L352.821 185.584C357.066 183.994 360.921 181.514 364.129 178.31L471.564 70.8751C471.564 70.8751 467.815 59.6414 456.592 48.4077C445.369 37.1846 434.125 33.4365 434.125 33.4365L326.69 140.871C323.486 144.078 321.006 147.934 319.416 152.179ZM449.107 18.4547L463.75 3.81168C466.375 1.18589 469.88 -0.486989 473.543 0.127107C478.7 0.974135 486.588 3.53639 494.02 10.9797C501.464 18.4229 504.026 26.3003 504.873 31.4566C505.487 35.12 503.814 38.6245 501.188 41.2503L486.535 55.8933C486.535 55.8933 482.797 44.6702 471.564 33.4471C460.34 22.2028 449.107 18.4547 449.107 18.4547Z" fill="black" />
            </svg>
          </li>
          <li ngbTooltip="Edit Shop Profile" (click)="open_shop_info_modal(shop_info_modal)">
            <svg viewBox="0 0 694 705" fill="none">
              <path d="M692.976 234L683.31 141.667C669.31 41 623.643 0 525.98 0H447.31H397.98H296.646H247.311H167.311C69.3112 0 23.9779 41 9.64458 142.667L0.644582 234.333C-2.68875 270 6.97792 304.667 27.9779 331.667C53.3112 364.667 92.3112 383.333 135.645 383.333C177.645 383.333 217.978 362.333 243.311 328.667C265.978 362.333 304.646 383.333 347.646 383.333C390.643 383.333 428.313 363.333 451.31 330C476.98 363 516.643 383.333 557.976 383.333C602.31 383.333 642.31 363.667 667.31 329C687.31 302.333 696.313 268.667 692.976 234Z" fill="black" />
              <path d="M325.959 513.675C283.626 518.008 251.627 554.008 251.627 596.675V688.008C251.627 697.008 258.96 704.341 267.96 704.341H426.959C435.959 704.341 443.292 697.008 443.292 688.008V608.341C443.626 538.675 402.626 505.675 325.959 513.675Z" fill="black" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M252.218 250.202L236.567 291.939C235.966 293.545 235.84 295.29 236.204 296.966C236.568 298.642 237.407 300.178 238.62 301.39C239.833 302.602 241.37 303.439 243.046 303.802C244.722 304.164 246.467 304.036 248.073 303.433L289.798 287.782C294.574 285.993 298.912 283.203 302.52 279.599L423.384 158.735C423.384 158.735 419.167 146.097 406.541 133.459C393.915 120.833 381.265 116.616 381.265 116.616L260.401 237.48C256.797 241.088 254.007 245.426 252.218 250.202ZM398.12 99.7615L414.593 83.2881C417.547 80.3341 421.49 78.4521 425.611 79.143C431.412 80.0959 440.286 82.9784 448.648 91.3521C457.022 99.7258 459.904 108.588 460.857 114.389C461.548 118.51 459.666 122.453 456.712 125.407L440.227 141.88C440.227 141.88 436.022 129.254 423.384 116.628C410.758 103.978 398.12 99.7615 398.12 99.7615Z" fill="white" />
              <path d="M660.02 438.27V537.603C660.02 629.603 585.353 704.27 493.353 704.27C484.353 704.27 477.02 696.937 477.02 687.937V608.27C477.02 565.604 464.02 532.27 438.686 509.603C416.353 489.27 386.02 479.27 348.353 479.27C340.02 479.27 331.686 479.604 322.686 480.604C263.352 486.604 218.352 536.604 218.352 596.604V687.937C218.352 696.937 211.018 704.27 202.018 704.27C110.018 704.27 35.3516 629.603 35.3516 537.603V438.937C35.3516 415.604 58.3516 399.937 80.0182 407.604C89.0182 410.604 98.0182 412.937 107.352 414.27C111.352 414.937 115.685 415.603 119.685 415.603C125.018 416.27 130.352 416.604 135.685 416.604C174.352 416.604 212.352 402.27 242.352 377.604C271.018 402.27 308.353 416.604 347.686 416.604C387.353 416.604 424.02 402.937 452.686 378.27C482.686 402.603 520.02 416.604 558.02 416.604C564.02 416.604 570.02 416.27 575.686 415.603C579.686 415.27 583.353 414.937 587.02 414.27C597.353 412.937 606.686 409.937 616.02 406.937C637.686 399.604 660.02 415.604 660.02 438.27Z" fill="black" />
            </svg>
          </li>
        </ul>
      </div>
    </div>
    <app-my-carousel-swiper class="my-carousel-width-auto" [slide]="get_selected_products_listing" [config]="carouselOptions">
      <div class="swiper-slide" *ngFor="let list of get_selected_products_listing">
        <div class="shop-myvip__my-card">
          <div class="image">
            <img loading="lazy" src="{{ imgUrl }}{{ list.foodImages[0].image }}" />
            <svg viewBox="0 0 1440 320">
              <path d="M0,160L80,138.7C160,117,320,75,480,74.7C640,75,800,117,960,144C1120,171,1280,181,1360,186.7L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
            </svg>
          </div>
          <div class="body">
            <div class="name">{{ list.name }}</div>
            <div class="desc">
              {{ list.description.substr(0, 60) }}
            </div>
            <div class="price">{{ list?.foodSpecs[0]?.key ? "$" + list?.foodSpecs[0]?.key : "" }}</div>
          </div>
          <!-- <a data-toggle="modal" data-target="#info_cart" (click)="newProduct()" class="slider_more_info">
            <i class="fas fa-info-circle more_info_icon" aria-hidden="true"></i>
          </a> -->
        </div>
      </div>
    </app-my-carousel-swiper>

    <div class="shop-myvip__product" [class.slider-left-inactive]="!menuSliderLeft">
      @if (menuSliderLeft) {
        <div class="side-left">
          <ul>
            <li>
              <div class="cate" [class.active]="selectedCatId == ''" (click)="featchMainCate('')">
                <div class="text">ALL</div>
                <div>
                  @if (loadingCate && this.selectedCatId == "") {
                    <span class="icon">
                      <span class="loader side-left-loading"></span>
                    </span>
                  }
                  <span class="icon add" (click)="newTab(catmodal)"> <i class="fa-solid fa-plus"></i> </span>
                  <span class="icon edit" (click)="openEditCatModal(editcatmodal)"> <i class="fa-solid fa-pencil-alt"></i> </span>
                  <span class="bg-icon bg-close" (click)="menuSliderLeft = !menuSliderLeft">
                    <span class="hamburger-icon" [class.icon-close]="menuSliderLeft">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </span>
                </div>
              </div>
            </li>
            @for (tab of categories; track tab) {
              <li>
                <div class="cate" [class.active]="this.selectedCatId == tab.id" (click)="featchMainCate(tab.id)">
                  <div class="text">{{ tab.name }}</div>
                  @if (loadingCate && this.selectedCatId == tab.id) {
                    <div class="loader side-left-loading"></div>
                  } @else {
                    <i class="fa-solid fa-angle-down"></i>
                  }
                </div>
                <ul class="sub-cate" [class.open]="this.selectedCatId == tab.id && !loadingCate">
                  <div class="buttons">
                    <span class="icon-sub add" (click)="newTab('sub')"> <i class="fa-solid fa-plus"></i> </span>
                    <span class="icon-sub edit" (click)="openEditSubCatModal(editsubcatmodal)"> <i class="fas fa-pencil-alt"></i> </span>
                  </div>
                  @for (t of subcategories; let i = $index; track t) {
                    <li [class.active]="this.selectedsubCatId == t.id" (click)="featchSubCate(tab.id, t.id)">{{ t.name }}</li>
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
      }

      <div>
        <div class="bar">
          <span class="hamburger-icon" [class.icon-close]="menuSliderLeft" (click)="menuSliderLeft = !menuSliderLeft">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <div class="buttons">
            <button class="my-button" (click)="newProduct()"><i class="fas fa-plus"></i>Add product</button>
          </div>
          <div class="search ml-2">
            <input type="text" (keyup)="filterProduct($event)" placeholder="Search for name or description..." />
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
        </div>

        @if (loadingProduct) {
          <div class="loader"></div>
        }
        <div class="products">
          @if (!loadingProduct) {
            @for (list of productAllProductListFiltered; track $index) {
              <div class="products__my-card" [class.active]="isSelectCarsouel(list.id)">
                <div class="carousel-active" (click)="select_product_for_slider(list.id)">
                  <svg viewBox="0 0 32 28" fill="none" class="ng-star-inserted">
                    <path d="M25 9L27 11L25 13" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7 9L5 11L7 13" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M29 21H3C1.9 21 1 20.1 1 19V3C1 1.9 1.9 1 3 1H29C30.1 1 31 1.9 31 3V19C31 20.1 30.1 21 29 21Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M16 27C16.5523 27 17 26.5523 17 26C17 25.4477 16.5523 25 16 25C15.4477 25 15 25.4477 15 26C15 26.5523 15.4477 27 16 27Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M10 27C10.5523 27 11 26.5523 11 26C11 25.4477 10.5523 25 10 25C9.44772 25 9 25.4477 9 26C9 26.5523 9.44772 27 10 27Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M22 27C22.5523 27 23 26.5523 23 26C23 25.4477 22.5523 25 22 25C21.4477 25 21 25.4477 21 26C21 26.5523 21.4477 27 22 27Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <div class="image">
                  <img loading="lazy" src="{{ imgUrl }}{{ list.primaryImage }}" />
                  <svg viewBox="0 0 1440 320">
                    <path d="M0,160L80,138.7C160,117,320,75,480,74.7C640,75,800,117,960,144C1120,171,1280,181,1360,186.7L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
                  </svg>

                  <div class="buttons">
                    <div class="icon edit" (click)="editProductModal(list.id)">
                      <i class="fas fa-pencil-alt"></i>
                    </div>
                    <div class="icon delete" (click)="delete_food(list.id)">
                      <i class="fa-solid fa-trash"></i>
                    </div>
                  </div>
                </div>
                <div class="body">
                  <div class="name">{{ list.name }}</div>
                  <div class="desc">
                    {{ list.description.substr(0, 60) }}
                  </div>
                  <div class="price">{{ list?.foodSpecs[0]?.key ? "$" + list?.foodSpecs[0]?.key : "" }}</div>
                  <!-- <div class="custom-control custom-radio custom-control-inline" *ngFor="let specs of list.foodSpecs">
                    <input type="radio" id="customRadioInline{{ specs.id }}" name="customRadioInline{{ specs.id }}" class="custom-control-input" disabled="disabled" checked />
                    <label class="custom-control-label spec_key_options" for="customRadioInline{{ specs.id }}"
                      >{{ specs.value }} - ${{ specs.nKey }} <span class="memPrice">${{ specs.key }}</span></label
                    >
                  </div> -->
                </div>
              </div>
            } @empty {
              <div class="not-found text-center mt-4">
                <i class="fa-solid fa-exclamation-circle fa-2x"></i>
                <div class="mt-2" style="font-size: 1.5rem">No Product found</div>
              </div>
            }
          }
        </div>
        @if (totalPages != currentPage && productAllProductListFiltered.length) {
          <div class="read-more">
            @if (readmore) {
              <div class="loader xs"></div>
            } @else {
              <div (click)="readMore()">Read More <i class="fa-solid fa-chevron-down"></i></div>
            }
          </div>
        }
      </div>
    </div>
    <!-- <div class="shop-myvip__news">
      <button class="my-button" (click)="openAddBottomImagesModal(addBottomImages)"><i class="fas fa-plus"></i> Add News</button>

      <owl-carousel-o [options]="customOptions2">
        <ng-container>
          <ng-template class="slide" carouselSlide *ngFor="let i of get_bottom_banner_response">
            <div class="fadd col-md-12 bottom_img_div">
              <i class="fas fa-pencil-alt edit_bottom_img" (click)="openEditBottomImagesModal(editBottomImages, i.id)"></i>
              <i style="padding: 5px 8px" class="fa-solid fa-times del_bottom_img" (click)="delete_bottom_banner(i.id)"></i>
              <a href="{{ i.url }}" target="_blank" class="bottom_img"><img loading="lazy" src="{{ imgUrl }}{{ i.image }}" /></a>
              <p class="bottom_banner_text">{{ i.title }}</p>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div> -->
  </div>
  <!-- <div class="add_cat_detail_edit" *ngIf="selectedCatId != '' && selectedsubCatId != ''">
    <a (click)="openChangeProductPosition(changeProductPosition)" data-toggle="modal">
      <i class="fas fa-pencil-alt"></i>
    </a>
  </div> -->
</ng-container>

<ng-template #catmodal let-modal>
  <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <div class="ml-auto">
            <h3>Add Category</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group description_text">
            <label> Category Name </label>
            <input type="text" [(ngModel)]="categoryName" class="form-control" *ngIf="!enableMemberShop" />
            <select class="form-control" [(ngModel)]="categoryName" *ngIf="enableMemberShop">
              <option value="" disabled>Select Category</option>
              <option *ngFor="let cat of memberShopCategories" [value]="cat.name">
                {{ cat.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="text-center d-flex justify-content-center">
            <button (click)="addCategory()" class="add-prod-btn px-2">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Common Use across platform sub-admin/member/template -->
<ng-template #editProduct let-modal>
  <!-- Loader -->
  <div class="form-loading" [ngClass]="{ active: enableLoader }">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <!-- Loader -->

  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="addProdDetail">
      <div class="addProdDetail__close" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-times"></i>
      </div>
      <form class="mt-2" [formGroup]="editprodForm">
        <div class="addProdDetail__body">
          <ng-container *ngIf="enableTemplateView">
            <section class="">
              <span class="font-bold"><b>Product Template : </b> </span>
              <input type="text" class="form-control w-50" formControlName="templateName" placeholder="Enter Template Name" />
            </section>
          </ng-container>
          <h5 *ngIf="!enableTemplateView">
            @if (customTitle) {
              {{ customTitle }} <span style="cursor: pointer" [routerLink]="['/advanced-settings']" [queryParams]="{ page: 3 }"><i class="fa-solid fa-gear"></i></span>
            } @else {
              @if (this.memberShopProductType == "promote") {
                {{ formType }} Shout Out
              } @else {
                {{ formType }} Product
              }
            }
            <!-- <span class="outOfStockSection" *ngIf="this.memberShopProductType != 'promote'">
              <span>
                <label> Out Of Stock </label>
                <input type="checkbox" class="check_box_all mx-0" formControlName="outOfStockAll" />
              </span>
            </span> -->
          </h5>
          <section class="error-block" *ngIf="errorList && errorList.length > 0">
            <ul>
              <li *ngFor="let i of errorList">{{ i }}</li>
            </ul>
          </section>

          <div class="row">
            <div class="col-md-7">
              <div class="row" *ngIf="enableMemberShop">
                <div class="col-6">
                  <div class="my-input category-shepherd">
                    <label>Category <span style="color: gray">*</span></label>
                    <app-multi-dropdown placeholder="Category" [placeholder]="selectedCategoryNameForDD && selectedCategoryNameForDD != 'null' ? selectedCategoryNameForDD : 'Category'" [items]="categoriesList" (itemSelected)="onCategoryChange($event?.categorieChildId, $event?.categoryName)"></app-multi-dropdown>
                  </div>
                </div>
                <div class="col-6">
                  <div class="my-input region-shepherd">
                    <label>Sub Region</label>
                    <app-multi-dropdown [placeholder]="subRegionName ? subRegionName : 'Sub-Region'" [items]="subRegionList" (itemSelected)="onSubRegionClick($event)" [disabled]="memberShopProductType != 'promote' && !roleService?.roles?.userType.includes('ADMIN')"></app-multi-dropdown>
                  </div>
                </div>
                <div class="m-2">
                  <div class="w-100 d-flex flex-wrap" style="gap: 0.2rem">
                    <button class="btn btn-sm btn-outline-primary m-1 types-btn" *ngFor="let type of currentProductCategoryAvailableTypes" (click)="toggleType(type)" [class.active]="typesOfProduct.has(type.id)">
                      {{ type.name }}
                    </button>
                  </div>
                </div>
              </div>
           
           
              <div *ngIf="isAdmin" class="d-flex my-2 align-items-center ">
                  <input class="mr-2" style="accent-color: var(--secondary)" type="checkbox" [checked]="isAd" (change)="isAd=$event.target.checked" />
                  <label style="margin: 0">Is Ad</label>
                  
              </div>

              <div *ngIf="isAdmin" class="d-flex my-2 align-items-center ">
                  <input class="mr-2" style="accent-color: var(--secondary)" type="checkbox" [checked]="isTypeShopProduct" (change)="isTypeShopProduct=$event.target.checked" />
                  <label style="margin: 0">Is Shop</label>
                  
              </div>
              <!-- <div class="form-group col-12 col-md-6">
                      
              </div> -->
              <div *ngIf="this.memberShopProductType == 'promote'" class ="d-flex justify-content-between">
                <div class="form-group">
                  <label for="">Product Based</label>
                  <div class="d-flex gap-1">
                    <div class="product-based-radio">
                      <input [(ngModel)]="basedProduct" value="home" type="radio" [ngModelOptions]="{ standalone: true }" id="home-radio" />
                      <label for="home-radio"><span>Home</span></label>
                    </div>
                    <div class="product-based-radio">
                      <input [(ngModel)]="basedProduct" value="business" type="radio" [ngModelOptions]="{ standalone: true }" id="business-radio" />
                      <label for="business-radio">
                        <span>Shout Out</span>
                      </label>
                    </div>
                  </div>
                </div>
             
                <div>
                   <label>Company Name</label>
                    <div class="input-group mb-2 position-relative">
                        <input type="text" formControlName="companyName" (keydown)="getCompanyNameSuggestions($event)" class="form-control" placeholder="Enter Company Name" />
                       
                        <div class="position-absolute w-100" style="top: calc(100%); z-index: 1000;" *ngIf="companyNameSearchSuggestions?.length">
                            <!-- <app-search-suggestion [searchSuggestions]="companyNameSearchSuggestions" ></app-search-suggestion> -->
                           <div *ngTemplateOutlet="companyNameSuggestionsModal"></div>
                        </div>

                    </div>
                </div>
               
              </div>
            </div>
            <div class="col-md-5">
              <!-- <ng-content></ng-content> -->
              <div class="my-input" *ngIf="enableMemberShop && userData?.enableTemplate && !enableTemplateView && !(enableMemberShop && enableTemplateView) && this.memberShopProductType != 'promote'">
                <div class="my-input template-shepherd">
                  <label>Select Template :</label>
                  <app-multi-dropdown placeholder="Template" [disabled]="!selectedCategoryNameForDD" [items]="selectedTemplateList" (itemSelected)="onTemplateChange($event.id)"></app-multi-dropdown>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-7">
              <div class="my-input name-shepherd">
                <label> Name <span style="color: gray">*</span></label>
                <input type="text" formControlName="name" placeholder value />
                <ng-container *ngIf="submitted && editproduct.name.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.name.errors.required">Product name is required!</p>
                </ng-container>
              </div>
            </div>
            <div class="col-md-7 mt-2 details-product-shepherd">
              <div class="btn-group mb-2 p-2 flex-wrap" style="overflow-x: scroll">
                <button (click)="isTabDescriptionActive = 1" class="btn btn-sm btn-{{ isTabDescriptionActive == 1 ? 'dark' : 'light' }}"><i class="fa-solid fa-info-circle"></i> Info <span style="color: gray">*</span></button>
                <!-- <ng-container *ngIf="memberShopProductType != 'promote'"> -->

                <button *ngIf="isTypeShopProduct" (click)="isTabDescriptionActive = 'promos'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'promos' ? 'dark' : 'light' }}"><i class="fa-sharp fa-solid fa fa-shopping-cart"></i> 
                    Promo/Shop <span style="color: gray">*</span></button>

                <button *ngIf="roleService.roles?.users?.includes('MEMBER_PRODUCT_DETAILS_TAB') && memberShopProductType != 'promote'" (click)="isTabDescriptionActive = 2" class="btn btn-sm btn-{{ isTabDescriptionActive == 2 ? 'dark' : 'light' }}"><i class="fa-solid fa-truck"></i> Details</button>
                <button (click)="isTabDescriptionActive = 3" class="btn btn-sm btn-{{ isTabDescriptionActive == 3 ? 'dark' : 'light' }}"><i class="fa-solid fa-dollar-sign"></i> Prices <span style="color: gray">*</span></button>
                <button *ngIf="memberShopProductType == 'rental' && memberShopProductType != 'promote'" (click)="isTabDescriptionActive = 'rent'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'rent' ? 'dark' : 'light' }}"><i class="fa-solid fa-dollar-sign"></i> Rent</button>
                <!-- </ng-container> -->
                <button (click)="isTabDescriptionActive = 4" class="btn btn-sm btn-{{ isTabDescriptionActive == 4 ? 'dark' : 'light' }}"><i class="fa-solid fa-location"></i> Location</button>
                <button *ngIf="this.memberShopProductType == 'promote'" (click)="isTabDescriptionActive = 'contact'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'contact' ? 'dark' : 'light' }}"><i class="fa-solid fa fa-phone"></i> Contact</button>
                <button *ngIf="this.memberShopProductType == 'promote'" (click)="isTabDescriptionActive = 'FAQs'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'FAQs' ? 'dark' : 'light' }}"><i class="fa-solid fa fa-check"></i> FAQs</button>
                <button *ngIf="this.memberShopProductType == 'promote'" (click)="isTabDescriptionActive = 'verified'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'verified' ? 'dark' : 'light' }}"><i class="fa-solid fa fa-check"></i> Verified</button>
                <button *ngIf="this.memberShopProductType == 'promote'" (click)="isTabDescriptionActive = 'moreService'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'moreService' ? 'dark' : 'light' }}"><i class="fa-solid fa-ellipsis"></i> Promo</button>
                <button *ngIf="this.memberShopProductType == 'promote' && roleService.roles?.users?.includes('SHOUT_CONTACT_TAB')" (click)="isTabDescriptionActive = 'profile'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'profile' ? 'dark' : 'light' }}"><i class="fa-solid fa fa-user"></i> Profile</button>
                <button *ngIf="this.memberShopProductType == 'promote' && roleService.roles?.users?.includes('SHOUT_CONTACT_TAB')" (click)="isTabDescriptionActive = 'meta'" class="btn btn-sm btn-{{ isTabDescriptionActive == 'meta' ? 'dark' : 'light' }}"><i class="fa-solid fa fa-cog"></i> Meta</button>
              </div>

              <div class="form-group d-{{ isTabDescriptionActive == 'promos' ? 'block' : 'none' }}">
                <span class="my-3" style="font-size: 1.3rem; font-weight: bold;">Promo Information</span>
                 <div class="d-flex flex-column w-100 align-items-center">
                     <div class="d-flex align-items-center flex-column position-relative">
                      <button class="t-btn position-absolute" style="top: .5rem; right: .5rem; color: red" *ngIf="detailsIconConvertedUrl" (click)="detailsIconConvertedUrl = ''; detailsIcon = null"><i class="fa fa-trash"></i></button>
                      <span style="font-size: 1rem; font-weight: 500; margin: .8rem 0;">Promo Details Logo</span>
                        <input type="file" class="d-none" id='selectShopIcon' (change)="setShopIcon($event)"/>
                        @if(detailsIconConvertedUrl){
                          <img [src]="detailsIconConvertedUrl"  (click)="clickButton('selectShopIcon')"  class="shadow"  style="height: 5rem; width: 20rem" />
                        }@else{
                           <img src="../../assets/images/uploadd2.png"  (click)="clickButton('selectShopIcon')"   style="height: 8rem; width: 8rem"  class="shadow"/>
                        }
                     </div>
                     <div>
                       
                     </div>
                 </div>
            

                  <form [formGroup]="editprodForm">
                  <div class="row mt-2 px-2">
                    <div class="form-group col-12">
                   
                      <div *ngFor="let item of editprodForm.get('tabsInfo').value; let i = index" class="w-100 mb-2 border p-3 rounded" [formGroupName]="i">
                        Tab {{i + 1}}
                        <input type="text" (change)="editprodForm.get('tabsInfo').value[i].title= $event.target.value" class="form-control my-2" rows="2"
                         placeholder="Tab Title" [value]="item?.title" />
                        <textarea (change)="editprodForm.get('tabsInfo').value[i].content = $event.target.value" class="form-control my-2" rows="2" placeholder="Tab Information">
                          {{ item.content ?? ''}}</textarea>
                        <div class="w-100 d-flex justify-content-between">
                         
                          <button type="button" class="btn btn-sm btn-danger mt-1" (click)="removeShopTab(i)"><i class="fa fa-trash"></i> Delete</button>
                        </div>
                      </div>

                      <button class="btn btn-outline-secondary" (click)="addShopTab()">Add Shop Tab</button>
                    </div>
                  </div>
                </form>
              </div>
              

              <div class="form-group d-{{ isTabDescriptionActive == 1 ? 'block' : 'none' }}">
                <textarea class="form-control" formControlName="descp" rows="14" maxlength="1000" placeholder></textarea>
                <div style="display: flex; justify-content: space-between">
                  <span>{{ 1000 - editprodForm.get("descp")?.value?.length }} Characters left</span>
                  <span *ngIf="roleService.roles?.users?.includes('ADD_PRODUCT_REFERRAL_STORE_LINK_CHECKBOX') && this.memberShopProductType != 'promote'">
                    <input type="checkbox" formControlName="storeLink" class="link-store ml-4" /> <label><span>Profile Link</span></label>
                  </span>
                </div>

                <ng-container *ngIf="submitted && editproduct.descp.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.descp.errors.required">Product description is required!</p>
                </ng-container>

                <div class="form-group d-none" [ngClass]="{ 'd-block': this.memberShopProductType == 'promote' && roleService.roles?.users?.includes('SHOUT_CONTACT_TAB') }">
                  <input type="text" class="form-control" formControlName="shoutInfo" placeholder="Bottom Promo Text " value="Default Shout Out Info" />
                </div>

                <div>
                  <input  
                    class="form-control"
                    placeholder="Custom Book Button Text"
                    type="text" [value]="customBookButton" (keyup)="customBookButton = $event.target.value" />
                 </div>

              </div>

              <div class="form-group d-{{ isTabDescriptionActive == 2 ? 'block' : 'none' }}">
                <textarea class="form-control" formControlName="charges" rows="14" placeholder></textarea>
                <ng-container *ngIf="submitted && editproduct.charges.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.charges.errors.required">Product charges is required!</p>
                </ng-container>
              </div>

              <!-- Rent -->
              <div class="form-group d-{{ isTabDescriptionActive == 'rent' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row">
                    <div class="form-group col-12 col-md-6">
                      <label>Deposit Amount</label>
                      <input type="text" formControlName="depositAmt" class="form-control" placeholder="Enter Deposit Amount" />
                      <ng-container *ngIf="submitted && editproduct.depositAmt.errors">
                        <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.depositAmt.errors.required">Deposit Amount is required!</p>
                      </ng-container>
                    </div>

                    <div class="form-group col-12 col-md-6">
                      <label>Estimate Value</label>
                      <input type="text" formControlName="estimateValue" class="form-control" placeholder="Enter Estimate Value" />
                    </div>

                    <div class="form-group col-12 col-md-6">
                      <label>Warranty Left (Months)</label>
                      <input type="text" formControlName="warranty" class="form-control" placeholder="Enter Warranty Left" />
                    </div>
                  </div>
                </form>
              </div>
              <!-- Rent -->

              <!-- Price -->
              <div class="form-group d-{{ isTabDescriptionActive == 3 ? 'block' : 'none' }}">
                <div class="d-flex mt-2 align-items-center justify-content-end">
                  <input type="checkbox" class="mr-2" id="allowShopPage" [checked]="editprodForm.get('shopPageEnabled').value" (change)="editprodForm.get('shopPageEnabled').value = $event.target.checked" />

                  <label style="margin-bottom: 0" for="allowShopPage">Allow Product To Have Shop Page</label>
                </div>
                <div class="col-md-12">
                  <div class="my-input unit-shepherd mb-2">
                    <label>Unit</label>
                    <input type="hidden" autofocus="true" />
                    <!-- <input type="text" autofocus="false" formControlName="unit" placeholder="Per Basket" /> -->
                    <select formControlName="unit" aria-placeholder="Select Unit" class="form-control">
                      <!-- <option selected disabled>Select Unit</option> -->
                      <option *ngFor="let item of ['From', 'Per Day', 'Per Meal', 'Per Hr', 'Per Item', 'Per Mth', 'Per Class', 'Per Trip']; index as i" [value]="item">{{ item }}</option>
                    </select>
                  </div>
                  <form [formGroup]="editprodForm">
                    <div class formArrayName="ingredientsEdit" style="max-height: 600px; overflow-y: auto; overflow-x: hidden">
                      <div class="card mb-2" style="background-color: #f6f6f6" *ngFor="let ingredientEdit of editprodForm.get('ingredientsEdit')['controls']; let i = index" [formGroupName]="i">
                        <div class="card-body d-flex">
                          <!------------------------------------------------------------------------------------------------->
                          <div class="h-100 d-flex flex-column justify-content-center mr-2" style="width: 25%">
                            <input type="file" (change)="setImageOfVariant($event, i)" style="visibility: hidden; width: 0" [id]="'imgVariant' + i" />
                            @if (encodedVariantBuffer[i]) {
                              <img class="variant-img" [src]="encodedVariantBuffer[i]" (click)="selectVariantImage(i)" />
                              <span class="delete-img"><i class="fa fa-trash" (click)="deleteVariantImage(i)" aria-hidden="true"></i></span>
                            } @else if (editprodForm?.get("ingredientsEdit")?.value[i]?.image?.trim()) {
                              <img class="variant-img" [src]="imgUrl + editprodForm.get('ingredientsEdit').value[i].image" (click)="selectVariantImage(i)" />
                              <span class="delete-img"><i class="fa fa-trash" (click)="deleteVariantImage(i)" aria-hidden="true"></i></span>
                            } @else {
                              <img class="variant-img" style="max-height: 50%; width: auto" src="../../assets/images/uploadd2.png" (click)="selectVariantImage(i)" />
                            }
                          </div>

                          <!------------------------------------------------------------------------------------------------->
                          <div class="row">
                            <div class="form-group col-md-6">
                              <label> Name {{ i == 0 ? "(Main)" : "" }} <span style="color: gray">*</span></label>
                              <input type="text" formControlName="weight" class="form-control" placeholder />
                              <ng-container *ngIf="submitted && editproduct.ingredientsEdit.controls[i].controls.weight.errors">
                                <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.ingredientsEdit.controls[i].controls.weight.errors.required">Name is required!</p>
                              </ng-container>
                            </div>

                            <div class="form-group col-6 col-md-4">
                              <label> Price <span style="color: gray">*</span> </label>
                              <ng-container *ngIf="memberShopProductType == 'bless'">
                                <input type="text" value="0" disabled class="form-control" placeholder />
                              </ng-container>
                              <ng-container *ngIf="memberShopProductType != 'bless'">
                                <input type="number" formControlName="price" [min]="0" (keydown)="preventInvalidInput($event)" class="form-control" placeholder />
                                <ng-container *ngIf="submitted && editproduct.ingredientsEdit.controls[i].controls.price.errors">
                                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.ingredientsEdit.controls[i].controls.price.errors.required">Member price is required!</p>
                                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="editproduct.ingredientsEdit.controls[i].controls.price.errors.min">Member price should be above zero!</p>
                                </ng-container>
                              </ng-container>
                            </div>

                            <div class="col-md-1 col-3 form-group">
                              <label> Action </label>
                              <i class="fas fa-trash-alt del_var_icon" (click)="removeIngredientEdit(i)"></i>
                            </div>

                            <div class="form-group col-md-12">
                              <label> Remarks </label>
                              <input type="text" formControlName="nprice" class="form-control" placeholder />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 text-center add_cat_detail_variants">
                      <a (click)="addIngredientEdit()"> <i class="fa-solid fa-plus"></i><span> Variations</span></a>
                    </div>
                  </form>
                </div>
              </div>
              <!-- Price -->
              <!-- Location -->
              <div class="form-group d-{{ isTabDescriptionActive == 4 ? 'block' : 'none' }}">
                <app-google-map [params]="maps" [isCommunity]="enableMemberShop && memberShopProductType != 'promote'" [readonly]="memberShopProductType != 'promote'" [mapName]="'google-map-body-add-product'" (changeRegion)="changeRegionByMaps($event)"></app-google-map>
              </div>
              <!-- Location -->
              <!-- Contact -->
              <div class="form-group d-{{ isTabDescriptionActive == 'contact' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row mt-2">
                    <div class="form-group col-12 col-md-6">
                      <label>Contact Number</label>
                      <div class="input-group mb-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text" style="padding: 2px 8px">+65</div>
                        </div>
                        <input type="text" formControlName="shoutContact" class="form-control" pattern="[0-9]*" minlength="8" maxlength="8" (keypress)="validateNumberInput($event)" (paste)="validateNumberPaste($event)" placeholder="Enter Contact Number" />
                      </div>
                    </div>

                    <div class="form-group col-12 col-md-6">
                      <label>Contact Relation <span style="color: gray">*</span></label>
                      <select formControlName="shoutContactRelation" class="form-control" placeholder="Select Contact Relation">
                        <option [value]="null" selected disabled>Select Contact Relation</option>
                        <option value="Direct family">Direct family</option>
                        <option value="Relative">Relative</option>
                        <option value="Good Friend">Good Friend</option>
                        <option value="Long time customer">Long time customer</option>
                        <option value="Friend’s friend">Friend’s friend</option>
                        <option value="Acquaintance">Acquaintance</option>
                      </select>
                    </div>

                    <div class="form-group col-12 col-md-6">
                      <label>Website</label>
                      <div class="input-group mb-2">
                        <input type="text" formControlName="shoutWebsite" class="form-control" placeholder="Enter Website" />
                      </div>
                    </div>

                    
                  </div>
                </form>
              </div>
              <!-- Contact -->

              <!---FAQ(product)-->
              <div class="form-group d-{{ isTabDescriptionActive == 'FAQs' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row mt-2 px-2">
                    <div class="form-group col-12">
                      <div *ngFor="let item of editprodForm.get('faqInfos').value; let i = index" class="w-100 mb-2" [formGroupName]="i">
                        <input class="form-control mb-2" [value]="editprodForm.get('faqInfos').value[i].question" type="text" placeholder="Question" (change)="editprodForm.get('faqInfos').value[i].question = $event.target.value" />

                        <textarea (change)="editprodForm.get('faqInfos').value[i].answer = $event.target.value" class="form-control" rows="2" placeholder="Enter FAQ Information">{{ editprodForm.get("faqInfos").value[i].answer }}</textarea>
                        <button type="button" class="btn btn-sm btn-danger mt-1" (click)="removeFAQ(i)">Delete</button>
                      </div>
                    </div>
                  </div>

                  <div class="px-2 w-100">
                    <button type="button" class="btn btn-sm btn-primary mt-1 w-100" (click)="addFAQ()">Add</button>
                  </div>
                </form>
              </div>
              <!---FAQ(product)-->

              <!-- Verified -->
              <div class="form-group d-{{ isTabDescriptionActive == 'verified' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row mt-2 px-2">
                    <div class="form-group col-12">
                      <!-- <label>Verified</label> -->
                      <div *ngFor="let item of editprodForm.get('verified').value; let i = index" class="w-100 mb-2" [formGroupName]="i">
                        <textarea (change)="editprodForm.get('verified').value[i].value = $event.target.value" class="form-control" rows="2" placeholder="Enter Verified Information">{{ item.value }}</textarea>
                        <div class="w-100 d-flex justify-content-between">
                          <span class="my-2">
                            <input type="checkbox" (change)="editprodForm.get('verified').value[i].isGolden = $event.target.checked ? 1 : 0" [checked]="editprodForm.get('verified').value[i].isGolden" />
                            <span class="ml-2">Golden</span>
                          </span>
                          <button type="button" class="btn btn-sm btn-danger mt-1" (click)="removeVerified(i)"><i class="fa fa-trash"></i> Delete</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label>Select Verified Tag:</label>
                    <select style="background: transparent; border: 0px" (change)="setVerifiedTag($event)">
                      <option [selected]="v.toLowerCase() == verifiedTag.toLowerCase()" *ngFor="let v of ['Verified', 'Unique', 'Preferred', 'Top Seller', 'HomeBased', 'Freelance', 'Chain']" [value]="v">{{ v }}</option>
                      <!-- <option value="Verified" >Verified</option>
                      <option value="Quality">Quality</option>
                      <option value="Value">Value</option>
                      <option value="Unique">Unique</option> -->
                    </select>
                  </div>

                  <div class="px-2 w-100">
                    <button type="button" class="btn btn-sm btn-primary mt-1 w-100" (click)="addVerified()">Add</button>
                  </div>
                </form>
              </div>
              <!-- Verified -->

              <!-- moreService -->
              <div class="form-group d-{{ isTabDescriptionActive == 'moreService' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row mt-2 px-2">
                    <div class="d-flex w-100 justify-content-end">
                      <input type="text" (keyup)="editprodForm.get('promoCode').value = $event.target.value" [value]="editprodForm.get('promoCode')?.value" placeholder="Promo Code" class="form-control mb-2" style="width: 8em" />
                    </div>

                    <div class="more-services">
                      <div *ngFor="let item of editprodForm.get('moreService').value; let i = index" class="more-service w-100 mb-2" [formGroupName]="i">
                        <div class="d-flex flex-column" style="position: relative">
                          <app-icon-selector (iconChange)="editprodForm.get('moreService').value[i].iconText = $event" style="position: absolute; top: 0; left: 0" [nowValue]="editprodForm.get('moreService').value[i].iconText" [icons]="moreServiceIcons"></app-icon-selector>
                          @if (encodedMorePromoBuffer[i]) {
                            <img class="more-service-img" [src]="encodedMorePromoBuffer[i]" (click)="selectMoreImage(i)" />
                            <span class="delete-img"><i class="fa fa-trash" (click)="deleteMoreServiceImg(i)" aria-hidden="true"></i></span>
                          } @else if (editprodForm?.get("moreService")?.value[i]?.imageFile?.trim()) {
                            <img class="more-service-img" [src]="imgUrl + editprodForm.get('moreService').value[i].imageFile" (click)="selectMoreImage(i)" />
                            <span class="delete-img"><i class="fa fa-trash" (click)="deleteMoreServiceImg(i)" aria-hidden="true"></i></span>
                          } @else {
                            <img class="more-service-img" style="max-height: 50%; width: auto" src="../../assets/images/uploadd2.png" (click)="selectMoreImage(i)" />
                          }

                          <input type="file" (change)="setImageOfMoreService($event, i)" style="visibility: hidden; width: 0" [id]="'img' + i" />
                        </div>

                        <div class="d-flex flex-column more-service-middle">
                          <div class="d-flex justify-content-start align-items-center mt-2">
                            <!-- [(ngModel)]="editprodForm.get('moreService').value[i].serviceComment" -->
                            <input maxlength="40" (change)="editprodForm.get('moreService').value[i].serviceComment = $event.target.value" [value]="editprodForm.get('moreService').value[i].serviceComment" class="form-control mb-2" rows="2" placeholder="Enter Information about the service." />
                          </div>

                          <textarea maxlength="255" (change)="editprodForm.get('moreService').value[i].serviceDescription = $event.target.value" placeholder="Enter more description about the service." class="form-control mb-2 mt-2" rows="2" style="height: 10em">{{ editprodForm.get("moreService").value[i].serviceDescription }}</textarea>
                          <div class="my-2 w-100 d-flex">
                            <div class="d-flex h-100 flex-column justify-content-center">
                              <label for="select-expiry" style="color: var(--primary)">Select Expiry:</label>
                            </div>
                            <div>
                              <select (change)="expiryStringChanged($event, i)" class="select-expiry ml-2">
                                <option *ngFor="let val of availableExpiryIntervals" class="p-2" [value]="val" [selected]="val == editprodForm.get('moreService')?.value[i]?.expiryInString">
                                  <!-- <input [id] = "'rd' + val" type="radio"   (change)="expiryStringChanged($event)" [(ngModel)]="editproexpiryInString'" class="mr-2" />
                                  <label [for]="'rd' + val">{{val}} </label> -->
                                  {{ val }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <!-- [(ngModel)]="editprodForm.get('moreService').value[i].referAmount" -->

                          <div class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 0">
                            <input type="checkbox" class="mr-2" [checked]="editprodForm.get('moreService').value[i].allowRefer" (change)="editprodForm.get('moreService').value[i].allowRefer = $event.target.checked" />
                            <label style="margin-bottom: 0">Allow users to refer this product</label>
                          </div>
                          <div *ngIf="editprodForm.get('moreService').value[i].allowRefer" class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 0">
                            <input type="checkbox" class="mr-2" [checked]="editprodForm.get('moreService').value[i].isPercentage" (change)="editprodForm.get('moreService').value[i].isPercentage = $event.target.checked" />
                            <label style="margin-bottom: 0">Is Percentage?</label>
                          </div>
                          <div *ngIf="editprodForm.get('moreService').value[i].allowRefer" class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 0">
                            <input type="checkbox" class="mr-2" [checked]="editprodForm.get('moreService').value[i].useOffText" (change)="editprodForm.get('moreService').value[i].useOffText = $event.target.checked" />
                            <label style="margin-bottom: 0">Use Off Text?</label>
                          </div>
                          <input *ngIf="editprodForm.get('moreService').value[i].allowRefer" (change)="editprodForm.get('moreService').value[i].referAmount = $event.target.value" [value]="editprodForm.get('moreService').value[i].referAmount" type="number" placeholder="$" class="mt-1 mb-1 form-control" />
                        </div>

                        <button type="button" class="btn btn-sm btn-danger mt-1 delete-btn" style="align-self: center" (click)="removeMoreService(i)"><i class="fa fa-trash"></i></button>
                      </div>
                    </div>
                  </div>

                  <div class="px-2 w-100">
                    <button type="button" class="btn btn-sm btn-primary mt-1 w-100" (click)="addMoreService()">Add</button>
                  </div>
                </form>
              </div>

              <!--moreService-->

              <!-- Profile -->
              <div class="form-group d-{{ isTabDescriptionActive == 'profile' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row">
                    <div class="col-md-6">
                      <label>Image</label>
                      <div class="grid-image">
                        <div class="image">
                          <input formControlName="shoutImage" type="file" #shoutImageFile (change)="onShoutImageSelected(shoutImageFile.files, product, $event)" accept="image/*" />
                          <img loading="lazy" #shoutImageElement [src]="shoutImage.includes('base64') ? shoutImage : imgUrl + shoutImage" class="food_img" (error)="commonService.handleErrorUpload($event)" />
                          <span class="delete-img" *ngIf="shoutImage"><i class="fa fa-trash" (click)="deleteImg('shoutImage')" aria-hidden="true"></i></span>
                          <span class="delete-img rotate-img" title="Rotate Image" *ngIf="shoutImage.includes('base64') || shoutImage" style=""><i class="fa fa-share" (click)="rotateImg(shoutImageElement, 'shoutImage')" aria-hidden="true"></i></span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="d-flex flex-wrap" style="gap: 0.5em">
                        <button *ngFor="let tab of shopProfileTabs; let i = index" (click)="shoutProfileMenu = i" class="btn btn-sm btn-{{ shoutProfileMenu == i ? 'dark' : 'light' }}">
                          {{ tab.title }}
                        </button>
                      </div>
                      <div *ngIf="shoutProfileMenu == 0">
                        <div class="form-group">
                          <label>Shop Profile</label>
                          <select formControlName="shopProfile" class="form-control" (change)="bizProfileChange($event)">
                            <option *ngFor="let profile of bizProfiles" [value]="profile.id">
                              {{ profile.shop_name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>Name</label>
                          <input type="text" formControlName="shoutName" class="form-control" placeholder="Enter Name" />
                        </div>

                        <div class="form-group">
                          <label>Link</label>
                          <input type="text" formControlName="shoutLink" class="form-control" placeholder="Enter Link" />
                        </div>

                        <div class="form-group">
                          <label>Description</label>
                          <textarea type="text" formControlName="shoutDescription" class="form-control" placeholder="Enter Description"></textarea>
                        </div>
                      </div>
                      <div *ngIf="shoutProfileMenu == 1" class="border p-3">
                        <!-- Google -->
                        <div class="form-group">
                          <label for="rating">Google Review</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" formControlName="googleReviewUrl" id="rating" aria-describedby="emailHelp" placeholder="Enter Google URL" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Google Rating / Count</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" formControlName="googleReviewRating" id="rating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                            <input type="number" class="form-control" formControlName="googleReviewCount" id="rating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                          </div>
                        </div>
                        <!-- Google -->
                        <!-- Carousell -->
                        <div class="form-group">
                          <label for="rating">Carousell Review</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" id="rating" formControlName="carousellReviewUrl" aria-describedby="emailHelp" placeholder="Enter Carousell URL" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Carousell Rating / Count</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" id="rating" formControlName="carousellReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                            <input type="number" class="form-control" id="rating" formControlName="carousellReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                          </div>
                        </div>
                        <!-- Carousell -->
                        <!-- FB -->
                        <div class="form-group">
                          <label for="rating">FB Review</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" id="rating" formControlName="fbReviewUrl" aria-describedby="emailHelp" placeholder="Enter FB URL" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">FB Rating / Count</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" id="rating" formControlName="fbReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                            <input type="number" class="form-control" id="rating" formControlName="fbReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                          </div>
                        </div>
                        <!-- FB -->
                      </div>
                      <div *ngIf="shoutProfileMenu == 2">
                        <div class="form-group">
                          <label for="rating">Website</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" id="rating" formControlName="websiteUrl" aria-describedby="emailHelp" placeholder="Enter Website URL" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Facebook</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" id="rating" formControlName="fbUrl" aria-describedby="emailHelp" placeholder="Enter Facebook URL" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Instagram</label>
                          <div class="input-group mb-2">
                            <div class="input-group-prepend">
                              <div class="input-group-text" style="padding: 2px 8px">https://</div>
                            </div>
                            <input type="text" class="form-control" id="rating" formControlName="instagramUrl" aria-describedby="emailHelp" placeholder="Enter Instagram URL" />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="shoutProfileMenu == 4" class="d-flex flex-column more-services">
                        <p class="form-group">Employees</p>
                        <!------------------------------------------------------------------------------------------------------------------->
                        <div *ngFor="let item of editprodForm.get('bizCompanyEmployees').value; let i = index" class="more-service w-100 mb-2" [formGroupName]="i">
                          <div class="d-flex flex-column" style="position: relative">
                            @if (encodedEmployeeBuffer[i]) {
                              <img class="more-service-img" [src]="encodedEmployeeBuffer[i]" (click)="selectEmployeeImage(i)" />
                              <span class="delete-img"><i class="fa fa-trash" (click)="deleteEmployeeServiceImg(i)" aria-hidden="true"></i></span>
                            } @else if (editprodForm?.get("bizCompanyEmployees")?.value[i]?.image?.trim()) {
                              <img class="more-service-img" [src]="imgUrl + editprodForm.get('bizCompanyEmployees').value[i].image" (click)="selectEmployeeImage(i)" />
                              <span class="delete-img"><i class="fa fa-trash" (click)="deleteEmployeeServiceImg(i)" aria-hidden="true"></i></span>
                            } @else {
                              <img class="more-service-img" style="max-height: 50%; width: auto" src="../../assets/images/uploadd2.png" (click)="selectEmployeeImage(i)" />
                            }
                            <div class="d-flex mt-2 w-50" style="gap: 0.5em">
                              <button class="" [ngStyle]="{ border: item.gender == 'M' ? '1px dashed var(--primary)' : 0 }" (click)="item.gender = 'M'">
                                <img src="../../assets/images/man-2.png" style="aspect-ratio: 1/1; width: 100%" />
                              </button>
                              <button class="" [ngStyle]="{ border: item.gender == 'F' ? '1px dashed var(--primary)' : 0 }" (click)="item.gender = 'F'">
                                <img src="../../assets/images/woman.png" style="aspect-ratio: 1/1; width: 100%" />
                              </button>
                            </div>

                            <input type="file" (change)="setImageOfEmployee($event, i)" style="visibility: hidden; width: 0" [id]="'imgEmp' + i" />
                          </div>

                          <div class="d-flex flex-column more-service-middle">
                            <div class="d-flex justify-content-start align-items-center mt-2 flex-column ml-2">
                              <!-- [(ngModel)]="editprodForm.get('moreService').value[i].serviceComment" -->
                              <input maxlength="40" (change)="editprodForm.get('bizCompanyEmployees').value[i].name = $event.target.value" [value]="editprodForm.get('bizCompanyEmployees').value[i].name" class="form-control mb-2" rows="2" placeholder="Enter Employee Name." />

                              <input maxlength="40" (change)="editprodForm.get('bizCompanyEmployees').value[i].title = $event.target.value" [value]="editprodForm.get('bizCompanyEmployees').value[i].title" class="form-control mb-2" rows="2" placeholder="Enter Employee title." />
                            </div>

                            <button type="button" class="btn btn-sm btn-danger mt-1 delete-btn" style="align-self: center" (click)="removeEmployeee(i)"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>

                        <!------------------------------------------------------------------------------------------------------------------->
                        <div class="px-2 w-100">
                          <button type="button" class="btn btn-sm btn-primary mt-1 w-100" (click)="addEmployee()">Add</button>
                        </div>
                      </div>
                      <div *ngIf="shoutProfileMenu == 3">
                        <!-- <p class="more-badges__title">More Badges</p> -->
                        <div class="form-group">
                          <label for="rating">Super Deal</label>
                          <div class="input-group mb-2">
                            <input type="text" class="form-control" formControlName="superDealText" id="rating" placeholder="Enter Super Deal text" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Super Deal Rating out of 5</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" min="0" max="5" formControlName="superDealRating" id="rating" style="background-color: #e9e0e038" placeholder="Enter Rating ★ ★" />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="rating">Best Price</label>
                          <div class="input-group mb-2">
                            <input type="text" class="form-control" formControlName="bestPriceText" id="rating" placeholder="Enter Best Price text" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">Best Price Rating out of 5</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" min="0" max="5" formControlName="bestPriceRating" id="rating" style="background-color: #e9e0e038" placeholder="Enter Rating ★ ★" />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="rating">High Quality</label>
                          <div class="input-group mb-2">
                            <input type="text" class="form-control" formControlName="highQualityText" id="rating" placeholder="Enter High Quality text" />
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="rating">High Quality Rating out of 5</label>
                          <div class="d-flex" style="gap: 5px">
                            <input type="number" class="form-control" min="0" max="5" formControlName="highQualityRating" id="rating" style="background-color: #e9e0e038" placeholder="Enter Rating ★ ★" />
                          </div>
                        </div>
                      </div>
                      <!-- </div> -->
                    </div>
                  </div>
                </form>
              </div>
              <!-- Profile -->

              <!-- meta -->
              <div class="form-group d-{{ isTabDescriptionActive == 'meta' ? 'block' : 'none' }}">
                <form [formGroup]="editprodForm">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Meta Data</label>
                        <textarea formControlName="metadata" class="form-control" placeholder="Enter Meta Data" rows="10"></textarea>
                      </div>
                      <!-- <div class="form-group">
                        <label>Schema</label>
                        <textarea formControlName="schema" class="form-control" placeholder="Enter Schema"
                          rows="10"></textarea>
                      </div> -->
                    </div>
                  </div>
                </form>
              </div>
              <!-- meta -->
            </div>
            <div class="col-md-5 mt-2 more-details-product-shepherd">
              <div class="btn-group mb-2" style="overflow-x: auto">
                <button (click)="isTabDetailActive = 1" class="btn btn-sm btn-{{ isTabDetailActive == 1 ? 'dark' : 'light' }}"><i class="fa-solid fa-image"></i> Main Image <span style="color: gray">*</span></button>
                <button *ngIf="(memberShopProductType != 'promote' && roleService.roles?.users?.includes('SELLER_INFO_TAB')) || !enableMemberShop" (click)="isTabDetailActive = 2" class="btn btn-sm btn-{{ isTabDetailActive == 2 ? 'dark' : 'light' }}"><i class="fa-solid fa-eye"></i> Seller Info</button>
                <button *ngIf="(memberShopProductType != 'promote' && roleService.roles?.users?.includes('MORE_PRODUCTS_TAB')) || !enableMemberShop" (click)="isTabDetailActive = 3" class="btn btn-sm btn-{{ isTabDetailActive == 3 ? 'dark' : 'light' }}"><i class="fa-solid fa-hashtag"></i> More Products</button>
              </div>
              <div class="d-{{ isTabDetailActive == 1 ? 'block' : 'none' }}">
                <div class="grid-images">
                  <div class="image">
                    <input formControlName="image1" type="file" #file1 (change)="onImageSelected1(file1.files, product, $event)" accept="image/*" />

                    @if (editprodForm.get("mainImageCropInformation")?.value) {
                      <app-cropped-image [imgSrc]="food_image_1_url.includes('base64') ? food_image_1_url : imgUrl + food_image_1_url" [cropInformation]="editprodForm.get('mainImageCropInformation')?.value"></app-cropped-image>
                    } @else {
                      <img loading="lazy" #Image1 [class.d-none]="editprodForm.get('mainImageCropInformation')?.value" [src]="food_image_1_url.includes('base64') ? food_image_1_url : imgUrl + food_image_1_url" class="food_img" (error)="commonService.handleErrorUpload($event)" />
                    }

                    <span class="delete-img" *ngIf="food_image_1_url"><i class="fa fa-trash" (click)="deleteImg('image1')" aria-hidden="true"></i></span>
                  
                    <span (click)="openCropModal(food_image_1_url.includes('base64') ? food_image_1_url : imgUrl + food_image_1_url)" *ngIf="food_image_1_url || food_image_1_url" class="crop-img btn btn-sm"><i class="fa-solid fa-scissors"></i> </span>
                    <span class="rotate-mainimg btn btn-sm" *ngIf="food_image_1_url" (click)="rotateImage($event, 'main')"> <i class="fa fa-rotate-left"></i></span>
                  </div>
                  <div class="image">
                    <span class="rotate-mainimg btn btn-sm" *ngIf="food_image_2_url" (click)="rotateImage($event, 'image2')"> <i class="fa fa-rotate-left"></i></span>

                    <input formControlName="image2" type="file" #file2 (change)="onImageSelected2(file2.files, product2, $event)" accept="image/*" />

                    @if (editprodForm.get("otherImagesCropInfo")?.value?.image2) {
                      <app-cropped-image [imgSrc]="food_image_2_url.includes('base64') ? food_image_2_url : imgUrl + food_image_2_url" [cropInformation]="editprodForm.get('otherImagesCropInfo')?.value?.image2"></app-cropped-image>
                    } @else {
                      <img loading="lazy" #Image2 [src]="food_image_2_url.includes('base64') ? food_image_2_url : imgUrl + food_image_2_url" class="food_img" (error)="commonService.handleErrorUpload($event)" />
                    }

                    <span class="delete-img" #Image2 *ngIf="food_image_2_url"><i class="fa fa-trash" aria-hidden="true" (click)="deleteImg('image2')"></i></span>
                 
                  </div>
                  <div class="image">
                    <span class="rotate-mainimg btn btn-sm" *ngIf="food_image_3_url" (click)="rotateImage($event, 'image3')"> <i class="fa fa-rotate-left"></i></span>
                    <input formControlName="image3" type="file" #file3 (change)="onImageSelected3(file3.files, product3, $event)" accept="image/*" />

                    @if (editprodForm.get("otherImagesCropInfo")?.value?.image3) {
                      <app-cropped-image [imgSrc]="food_image_3_url.includes('base64') ? food_image_3_url : imgUrl + food_image_3_url" [cropInformation]="editprodForm.get('otherImagesCropInfo')?.value?.image3"></app-cropped-image>
                    } @else {
                      <img loading="lazy" #Image3 [src]="food_image_3_url.includes('base64') ? food_image_3_url : imgUrl + food_image_3_url" class="food_img" (error)="commonService.handleErrorUpload($event)" />
                    }

                    <span class="delete-img" *ngIf="food_image_3_url"><i class="fa fa-trash" aria-hidden="true" (click)="deleteImg('image3')"></i></span>
                 
                  </div>
                  <div class="image">
                    <span class="rotate-mainimg btn btn-sm" *ngIf="food_image_4_url" (click)="rotateImage($event, 'image4')"> <i class="fa fa-rotate-left"></i></span>
                    <input formControlName="image4" type="file" #file4 (change)="onImageSelected4(file4.files, product4, $event)" accept="image/*" />

                    @if (editprodForm.get("otherImagesCropInfo")?.value?.image4) {
                      <app-cropped-image [imgSrc]="food_image_4_url.includes('base64') ? food_image_4_url : imgUrl + food_image_4_url" [cropInformation]="editprodForm.get('otherImagesCropInfo')?.value?.image4"></app-cropped-image>
                    } @else {
                      <img loading="lazy" #Image4 [src]="food_image_4_url.includes('base64') ? food_image_4_url : imgUrl + food_image_4_url" class="food_img" (error)="commonService.handleErrorUpload($event)" />
                    }

                    <span class="delete-img" *ngIf="food_image_4_url"><i class="fa fa-trash" aria-hidden="true" (click)="deleteImg('image4')"></i></span>
                   
                  </div>
                </div>
              </div>

              <div class="d-{{ isTabDetailActive == 2 ? 'block' : 'none' }}">
                <div class="form-group">
                  <div class="form-group">
                    <label> Chat URL </label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text" style="padding: 2px 8px">https://wa.me/</div>
                      </div>
                      <input type="text" formControlName="chat_url" class="form-control" placeholder value />
                    </div>
                  </div>
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: selMenu == 'reviews' }" (click)="selectMenu('reviews')">Reviews</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: selMenu == 'social' }" (click)="selectMenu('social')">Social</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: selMenu == 'seller-info' }" (click)="selectMenu('seller-info')">Seller Info</a>
                    </li>
                  </ul>
                  <!-- reviews/social/seller-info Tab -->
                  <form [formGroup]="shopForm">
                    <section *ngIf="selMenu == 'reviews'" class="border p-3">
                      <!-- Google -->
                      <div class="form-group">
                        <label for="rating">Google Review</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" formControlName="googleReviewUrl" aria-describedby="emailHelp" placeholder="Enter Google URL" />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="rating">Google Rating / Count</label>
                        <div class="d-flex" style="gap: 5px">
                          <input type="text" class="form-control" formControlName="googleReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                          <input type="text" class="form-control" formControlName="googleReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                        </div>
                      </div>
                      <!-- Google -->
                      <!-- Carousell -->
                      <div class="form-group">
                        <label for="rating">Carousell Review</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" id="rating" formControlName="carousellReviewUrl" aria-describedby="emailHelp" placeholder="Enter Carousell URL" />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="rating">Carousell Rating / Count</label>
                        <div class="d-flex" style="gap: 5px">
                          <input type="text" class="form-control" id="rating" formControlName="carousellReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                          <input type="text" class="form-control" id="rating" formControlName="carousellReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                        </div>
                      </div>
                      <!-- Carousell -->
                      <!-- FB -->
                      <div class="form-group">
                        <label for="rating">FB Review</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" id="rating" formControlName="fbReviewUrl" aria-describedby="emailHelp" placeholder="Enter FB URL" />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="rating">FB Rating / Count</label>
                        <div class="d-flex" style="gap: 5px">
                          <input type="text" class="form-control" id="rating" formControlName="fbReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
                          <input type="text" class="form-control" id="rating" formControlName="fbReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
                        </div>
                      </div>
                      <!-- FB -->
                    </section>
                    <section *ngIf="selMenu == 'social'" class="border p-3">
                      <div class="form-group">
                        <label for="rating">Website</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" id="rating" formControlName="websiteUrl" aria-describedby="emailHelp" placeholder="Enter Website URL" />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="rating">Facebook</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" id="rating" formControlName="fbUrl" aria-describedby="emailHelp" placeholder="Enter Facebook URL" />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="rating">Instagram</label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text" style="padding: 2px 8px">https://</div>
                          </div>
                          <input type="text" class="form-control" id="rating" formControlName="instagramUrl" aria-describedby="emailHelp" placeholder="Enter Instagram URL" />
                        </div>
                      </div>
                    </section>
                    <section *ngIf="selMenu == 'seller-info'" class="border p-3">
                      <textarea class="form-control" formControlName="sellerInfo" rows="8" placeholder></textarea>
                    </section>
                  </form>
                  <!-- reviews/social/seller-info Tab -->
                </div>
                <!-- <div class>
                  <label> Add Category </label>
                </div>
                <div class="form-row">
                  <div class="form-group prod_upld_icon col-md-3 col-3" (click)="show_add_icon_modal(add_icon_modal, item, i)" *ngFor="let item of icons; let i = index">
                    <img loading="lazy" src="../../../../assets/images/uploadd3.png" />
                    <span class="text-center">{{ item.value }}</span>
                  </div>
                </div> -->
              </div>

              <div class="d-{{ isTabDetailActive == 3 ? 'block' : 'none' }}">
                <div class="form-group" *ngIf="!enableMemberShop || (enableMemberShop && roleService?.roles?.userType.includes('ADMIN'))">
                  <label>More Products</label>

                  <select2 [data]="moreProductsSelect" [multiple]="true" [displaySearchStatus]="always" ngDefaultControl formControlName="more_products"> </select2>
                </div>
              </div>

              <div class="nav-booking" *ngIf="memberShopProductType != 'promote'">
                <div class="my-checkbox" *ngIf="roleService.roles?.users?.includes('CALENDER_ADD_HOLIDAY') || !enableMemberShop">
                  <input id="booking" type="checkbox" formControlName="dateCheckBox" (change)="isProductTimeToggle($event)" />
                  <label for="booking"><span>CALENDER</span></label>
                </div>
                <button *ngIf="isProductTime" class="button-2" (click)="holidayToggle()">ADD HOLIDAYS</button>

                <!-- <input
                  type="datetime-local"
                  formControlName="product_date"
                  value={{dateFromDb}}
                  id="date"
                  (change)="onDateChange($event)"
                  style="box-shadow: 0 0 3px #ced4da;height: 50px;width: 303px;"
                  disabled>               -->
              </div>
              <div class="text-right" *ngIf="isProductTime">
                <!-- <button class="btn btn-primary" style="margin-top: 10px;margin-left: 88px;" (click)="holidayToggle()">
                  {{ selectedDates.length ? 'EDIT HOLIDAYS' : 'ADD HOLIDAYS' }}
                </button>                       -->
                <ngb-datepicker
                  #dp
                  *ngIf="selectHoliday"
                  [minDate]="{
                    year: today.getFullYear(),
                    month: today.getMonth() + 1,
                    day: today.getDate() + 1,
                  }"
                  [dayTemplate]="holidayDatePicker"
                  outsideDays="hidden"
                  (dateSelect)="onDateSelect($event)"
                >
                </ngb-datepicker>
                <ng-template #holidayDatePicker let-date="date" let-focused="focused">
                  <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
                    {{ date.day }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button type="button" (click)="submit()" [disabled]="enableLoader" class="submit_prod border-0">{{ enableLoader ? "Loading" : "Submit" }}</button>&nbsp;
            <button type="button" (click)="modalService.dismissAll()" [disabled]="enableLoader" class="submit_prod border-0 cancel_button">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #subcatmodal let-modal>
  <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Add Sub Category</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group description_text">
            <label> Sub Category Name </label>
            <input [(ngModel)]="subcategoryName" type="text" class="form-control" *ngIf="!enableMemberShop" />
            <select class="form-control" [(ngModel)]="subcategoryName" *ngIf="enableMemberShop">
              <option value="" disabled>Select Subcategory</option>
              <option *ngFor="let cat of memberShopSubcategories" [value]="cat.name">
                {{ cat.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="d-flex justify-content-center">
            <button (click)="addSubCat()" class="add-prod-btn px-2">Submit</button>
          </div>
          <!-- <div class="col-md-12 text-center mt-3">
            <a (click)="modalService.dismissAll()" style="background: transparent; height: 34px">
              <img loading="lazy" style="height: 38px; width: 38px" src="../../../../assets/images/backcu.png" /></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- <ng-template #add_icon_modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Icon</h4>
    <a (click)="modal.dismiss('Cross click')" id="closeIconModal"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <form class="mt-n1">
      <div class="form-group">
        <label for="">Type</label>
        <select [(ngModel)]="focusIcon.value" (change)="handleTypeIcon()" [ngModelOptions]="{ standalone: true }" class="form-control">
          <option value="" selected disabled>Select Type</option>
          <option [value]="row" *ngFor="let row of focusIcon.dropdown">
            {{ row }}
          </option>
        </select>
      </div>
      <div class="form-group" *ngIf="focusIcon.showText">
        <label for="">Text</label>
        <textarea disabled rows="4" [ngModelOptions]="{ standalone: true }" [(ngModel)]="focusIcon.text" class="form-control"></textarea>
      </div>
      <div class="mt-3">
        <button class="btn btn-danger mr-2" (click)="saveIcon(true)"><i class="fa-solid fa-times"></i> Cancel</button>
        <button class="btn btn-primary" (click)="saveIcon()"><i class="fa-solid fa-save"></i> Save</button>
      </div>
    </form>
  </div>
</ng-template> -->

<ng-template #editcatmodal let-modal>
  <div class="my-edit-cat-modal__header">
    <div class="title">Edit Category</div>
    <button class="btn-close" [disabled]="isUploading" (click)="modalService.dismissAll()"></button>
  </div>
  <div class="my-list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (cat of categories; track cat) {
      <div class="my-box" cdkDrag>
        <label> Category Name </label>
        <div class="my-input-drop">
          <select class="form-control" [(ngModel)]="cat.name" *ngIf="enableMemberShop">
            <option value="" selected>NULL</option>
            <option *ngFor="let cat of memberShopCategories" [value]="cat.name">
              {{ cat.name }}
            </option>
          </select>
          <input type="text" *ngIf="!enableMemberShop" [(ngModel)]="cat.name" class="form-control" />
          <i class="fas fa-times-circle fa-2x" (click)="delete_food_category(cat.id)"></i>
          <i class="fas fa-eye fa-2x" (click)="hide_unhide_cat(cat.id)" *ngIf="cat.isHide == 0"></i>
          <i class="fas fa-eye-slash fa-2x" (click)="hide_unhide_cat(cat.id)" *ngIf="cat.isHide == 1"></i>
          <input type="file" #CatImageUpload (change)="uploadCatImage($event, cat.id)" class="suggestion-modal-pic-input d-none" accept="image/*" />
          <i class="fas fa-image" style="right: 4.6rem" [title]="cat?.image ? 'Edit Image' : 'Add Image'" [ngClass]="{ 'bg-yellow': cat?.image }" (click)="CatImageUpload.click()"></i>
        </div>
      </div>
    }
  </div>
  <button (click)="editCategory()" class="my-button">Update</button>
  <!-- <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row" *ngIf="!enableMemberShop">
        <div class="col-md-12 d-flex">
          <div class="add_cattt ml-auto">
            <h3>Hide Member Price</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-7 mx-auto" *ngIf="!enableMemberShop">
        <input type="checkbox" class="form-control showHideCheckbox" *ngIf="showHideMemberPriceStatus == 0" (click)="update_show_hide_status()" />
        <input type="checkbox" class="form-control showHideCheckbox" checked *ngIf="showHideMemberPriceStatus == 1" (click)="update_show_hide_status()" />
      </div>
      <hr />
    </div>
  </div> -->
</ng-template>

<ng-template #addBannerModal let-modal>
  <div class="my-upload-banner-modal__header">
    <div class="title">Upload Banner</div>
    <button class="btn-close" [disabled]="isUploading" (click)="modalService.dismissAll()"></button>
  </div>
  <form [formGroup]="bannerForm">
    <div class="upload-image">
      <input formControlName="banner" type="file" #banner (change)="onBannerSelected(banner.files, $event)" accept="image/*" />
      <img loading="lazy" *ngIf="banner_image_url" [src]="banner_image_url" alt="Thumbnail Preview" />
      <div *ngIf="!banner_image_url">
        <svg viewBox="0 0 700 662" fill="none">
          <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z" fill="var(--primary)" />
          <path d="M699.844 353.203C699.844 441.953 627.891 513.984 539.141 514.062H411.563V479.688H539.141C572.891 479.688 604.609 466.484 628.438 442.656C652.344 418.75 665.469 387.031 665.469 353.203C665.469 319.453 652.344 287.656 628.438 263.828C604.531 240 572.734 226.797 538.984 226.797C530 226.797 521.172 227.734 512.578 229.531C500.859 232.031 489.609 236.094 479.141 241.797C478.359 229.766 476.562 217.813 473.828 206.172V206.094C471.016 193.906 467.109 182.031 462.188 170.391C450.938 143.906 434.922 120.078 414.453 99.6094C393.984 79.1406 370.234 63.125 343.672 51.875C316.25 40.3125 287.109 34.375 257.031 34.375C226.953 34.375 197.813 40.2344 170.391 51.875C143.906 63.0469 120.078 79.1406 99.6094 99.6094C79.1406 120.078 63.125 143.906 51.875 170.391C40.2344 197.812 34.375 226.953 34.375 257.031C34.375 287.109 40.2344 316.25 51.875 343.672C63.0469 370.156 79.1406 393.984 99.6094 414.453C120.078 434.922 143.906 450.937 170.391 462.187C197.813 473.75 226.953 479.688 257.031 479.688H288.047V514.062H256.016C114.531 513.516 0 398.672 0 257.031C0 115.078 115.078 0 257.031 0C377.813 0 479.141 83.2813 506.641 195.547V195.625C517.109 193.516 527.891 192.344 538.984 192.344C627.813 192.422 699.844 264.375 699.844 353.203Z" fill="#39393A" />
          <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z" fill="var(--primary)" />
        </svg>
        <div [class.error]="submitted && bannerControl.banner.errors && bannerControl.banner.errors.required">Please select a banner to upload.</div>
      </div>
    </div>
    <div class="all-progress" [class.active]="submitted && uploadProgress > 0">
      <p>Uploading... {{ uploadProgress }}%</p>
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
      </div>
    </div>
    <button class="my-button" (click)="addBanner()" [disabled]="submitted">Upload</button>
  </form>
  <div class="grid-banner">
    <div class="edit_banners_modal" *ngFor="let data of get_all_product_banner_response">
      <span><i class="fas fa-times-circle" (click)="delete_product_banner(data.id)"></i></span>
      <img loading="lazy" src="{{ imgUrl }}{{ data.image }}" />
    </div>
  </div>
</ng-template>

<ng-template #editsubcatmodal let-modal>
  <div class="my-edit-cat-modal__header">
    <div class="title">Edit Sub Category</div>
    <button class="btn-close" [disabled]="isUploading" (click)="modalService.dismissAll()"></button>
  </div>
  <div class="my-list" cdkDropList (cdkDropListDropped)="drop2($event)">
    @for (cat of subcategories; track cat) {
      <div class="my-box" cdkDrag>
        <label>Sub Category Name </label>
        <div class="my-input-drop">
          <input type="text" [(ngModel)]="cat.name" class="form-control" *ngIf="!enableMemberShop" />
          <select class="form-control" [(ngModel)]="cat.name" *ngIf="enableMemberShop">
            <option value="" disabled>Select subcategory</option>
            <option *ngFor="let cat of memberShopSubcategories" [value]="cat.name">
              {{ cat.name }}
            </option>
          </select>
          <i class="fas fa-times-circle fa-2x sub_del_icon" (click)="delete_food_subategory(cat.id)"></i>
        </div>
      </div>
    }
  </div>
  <button (click)="editSubCategory()" class="my-button">Update</button>
</ng-template>

<!-- <ng-template #changeProductPosition let-modal>
  <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <h3>Change Product Position</h3>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-7 mx-auto">
        <div class="row">
          <div class="example-list" cdkDropList (cdkDropListDropped)="drop3($event)">
            <div class="example-box" *ngFor="let list of food_listing_response" cdkDrag>
              <label> Product Name </label>
              <input type="text" [(ngModel)]="list.name" class="form-control" disabled />
            </div>
          </div>
          <div class="col-md-12">
            <div class="text-center mt-3">
              <a (click)="editProductPosition()" class="description_btn"> Update </a>
            </div>
          </div>
          <div class="col-md-12 text-center mt-3">
            <a (click)="modalService.dismissAll()" style="background: transparent; height: 34px"> <img loading="lazy" style="height: 38px; width: 38px" src="../../../../assets/images/backcu.png" /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->

<ng-template #addBottomImages let-modal>
  <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Add News</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="bottomImagesForm">
              <div class="form-group col-md-6 mx-auto prod_upld">
                <input formControlName="banner" type="file" #banner (change)="onBottomBannerSelected(banner.files, $event)" accept="image/*" />
                <img loading="lazy" src="../../../../assets/images/uploadd1.png" *ngIf="bottom_banner_image_url_show != 1" class="food_img bottom_banner_img" />
                <img loading="lazy" src="{{ bottom_banner_image_url }}" *ngIf="bottom_banner_image_url && bottom_banner_image_url_show == 1" class="food_img" />
                <ng-container *ngIf="submitted && bottomBannerControl.banner.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControl.banner.errors.required">Please select image</p>
                </ng-container>
              </div>

              <div class="form-group">
                <label>Title</label>
                <input type="text" class="form-control" formControlName="title" />
                <ng-container *ngIf="submitted && bottomBannerControl.title.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControl.title.errors.required">Please enter title</p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Text</label>
                <app-editor [(innerValue)]="ckEditorText"></app-editor>
                <ng-container *ngIf="submitted">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="ckEditorText == ''">Please enter text</p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Author</label>
                <input type="text" class="form-control" formControlName="author" />
                <ng-container *ngIf="submitted && bottomBannerControl.author.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControl.author.errors.required">Please enter author</p>
                </ng-container>
              </div>

              <!-- <div class="form-group">
                <label>URL</label>
                <input type="text" class="form-control" formControlName="url">
                <ng-container
                  *ngIf="submitted && bottomBannerControl.url.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControl.url.errors.required">
                    Please enter URL
                  </p>
                </ng-container>
              </div> -->

              <div class="d-flex justify-content-center" style="padding: 4px; width: 100%">
                <button (click)="addBottomBanner()" class="add-prod-btn px-2">Submit</button>
              </div>
            </form>
          </div>

          <!-- <div class="col-md-12 text-center mt-3">
            <a (click)="modalService.dismissAll()" style="background: transparent; height: 34px">
              <img loading="lazy" style="height: 38px; width: 38px" src="../../../../assets/images/backcu.png" /></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editBottomImages let-modal>
  <div class="modal-content">
    <div class></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <h3>Edit News</h3>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="bottomImagesFormEdit">
              <div class="form-group col-md-6 mx-auto prod_upld">
                <input formControlName="banner" type="file" #banner (change)="onBottomBannerSelected(banner.files, $event)" accept="image/*" />

                <img loading="lazy" src="../../../../assets/images/uploadd1.png" *ngIf="bottom_banner_image == '' && bottom_banner_image_url_show != 1" class="food_img bottom_banner_img" />
                <img loading="lazy" src="{{ bottom_banner_image_url }}" *ngIf="bottom_banner_image_url && bottom_banner_image_url_show == 1" class="food_img" />
                <img loading="lazy" src="{{ imgUrl }}{{ bottom_banner_image }}" *ngIf="bottom_banner_image != '' && bottom_banner_image_url_show != 1" class="food_img" />

                <ng-container *ngIf="submitted && bottomBannerControlEdit.banner.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControlEdit.banner.errors.required">Please select image</p>
                </ng-container>
              </div>

              <div class="form-group">
                <label>Title</label>
                <input type="text" class="form-control" formControlName="title" />
                <ng-container *ngIf="submitted && bottomBannerControlEdit.title.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControlEdit.title.errors.required">Please enter title</p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Text</label>
                <app-editor [(innerValue)]="ckEditorText"></app-editor>
                <ng-container *ngIf="submitted">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="ckEditorText == ''">Please enter text</p>
                </ng-container>
              </div>
              <div class="form-group">
                <label>Author</label>
                <input type="text" class="form-control" formControlName="author" />
                <ng-container *ngIf="submitted && bottomBannerControlEdit.author.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px" *ngIf="bottomBannerControlEdit.author.errors.required">Please enter author</p>
                </ng-container>
              </div>

              <!-- <div class="form-group">
                <label>URL</label>
                <input type="text" class="form-control" formControlName="url">
                <ng-container
                  *ngIf="submitted && bottomBannerControlEdit.url.errors">
                  <p class="error-message" style="padding: 0px; font-size: 12px"
                    *ngIf="bottomBannerControlEdit.url.errors.required">
                    Please enter URL
                  </p>
                </ng-container>
              </div> -->

              <div class="text-center" style="padding: 4px">
                <a (click)="editBottomBanner()" class="description_btn"> Submit </a>
              </div>
            </form>
          </div>

          <div class="col-md-12 text-center mt-3">
            <a (click)="modalService.dismissAll()" style="background: transparent; height: 34px"> <img loading="lazy" style="height: 38px; width: 38px" src="../../../../assets/images/backcu.png" /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #shop_info_modal let-modal>
  <div class="my-shop-info__header">
    <!-- @if(enableMemberShop) {
    <div class="banner"></div>
    } @else {
    <div class="banner">
      <div class="edit">
        <i class="fa-solid fa-pen-to-square"></i>
      </div>
      <input type="file" #fileInput (change)="onBannerPhotoSelected(fileInput.files, $event)" accept="image/*" />
      <i class="fa-solid fa-camera" *ngIf="!shop_Banner_image_show && !shop_banner"></i>
      <img loading="lazy" *ngIf="shop_banner && !shop_Banner_image_show" [src]="imgUrl + shop_banner" />
      <img loading="lazy" *ngIf="shop_Banner_image_show" [src]="shop_Banner_image_url" />
    </div>
    } -->
    <div class="banner">
      @if (get_all_product_banner_response[0]?.image) {
        <img loading="lazy" [src]="imgUrl + get_all_product_banner_response[0].image" />
      } @else {
        <i class="fa-solid fa-camera"></i>
      }
    </div>

    <div class="body">
      <div class="shop-image">
        <i class="fa-solid fa-pencil"></i>
        <input type="file" #file1 (change)="onLogoSelected(file1.files, $event)" accept="image/*" />
        <i class="fa-solid fa-camera" *ngIf="logo_image_show != 1 && shop_logo == ''"></i>
        <img loading="lazy" src="{{ imgUrl }}{{ shop_logo }}" *ngIf="shop_logo !== '' && logo_image_show !== 1" />
        <img loading="lazy" src="{{ logo_image_url }}" *ngIf="logo_image_url && logo_image_show == 1" />
      </div>
      <div class="shop-details">
        <div>
          @if (editNameShop) {
            <input type="text" class="form-control" [(ngModel)]="shopName" />
          } @else {
            <div class="name" (click)="editNameShop = true">{{ shopName || "Add Name for your shop" }}<i class="fa-regular fa-pen-to-square"></i></div>
          }
          @if (editDescShop) {
            <textarea placeholder="Shop Description" [(ngModel)]="shop_description" name="shop_description" class="form-control mt-2"> </textarea>
          } @else {
            <div class="desc" (click)="editDescShop = true">{{ shop_description || "Add Description for your shop" }}<i class="fa-regular fa-pen-to-square"></i></div>
          }
        </div>
        <div class="qr">
          <qrcode #qrCodeImage [elementType]="elementType" [qrdata]="QrCodeValue" [errorCorrectionLevel]="'M'"></qrcode>
          <button class="my-button-3" [class.blue]="!enableMemberShop" (click)="selShopMenu == 'profile' ? (selShopMenu = 'seller-info') : (selShopMenu = 'profile')">{{ selShopMenu == "profile" ? "profile" : "Seller Info" }}</button>
        </div>
      </div>
      <div class="buttons">
        <div (click)="addMember(null, AddMemberShop)" class="my-btn"><i class="fa-solid fa-plus"></i> {{ memberList && memberList.length ? "View" : "Add" }} Member</div>
        <a (click)="openShopPage()" class="my-btn"> <i class="fa-solid fa-link"></i> View Shop </a>
        <div (click)="onClickVoucher()" class="my-btn">
          <svg viewBox="0 0 800 800" fill="none">
            <path d="M800 54.5008C800.061 39.893 794.423 26.1789 784.127 15.882C773.83 5.58514 760.089 -0.0429867 745.509 0.0101383C730.944 0.0710758 717.231 5.79451 706.898 16.1258C702.523 20.5008 694.566 29.9508 690.212 35.1961C685.641 40.7039 686.397 48.8758 691.905 53.4461C697.411 58.018 705.583 57.2617 710.155 51.7539C716.973 43.5414 722.609 37.0742 725.227 34.4555C730.692 28.9914 737.933 25.9633 745.617 25.9304C745.659 25.9304 745.698 25.9304 745.741 25.9304C753.337 25.9304 760.458 28.8679 765.798 34.2101C771.169 39.5804 774.111 46.7476 774.078 54.3914C774.045 62.0742 771.017 69.3148 765.553 74.782C760.661 79.6742 743.845 93.0133 719.753 109.843C705.502 85.4773 679.07 69.0633 648.863 69.0633H459.075C433.456 69.0633 409.372 79.0398 391.255 97.1539L11.8953 476.518C4.225 484.188 0 494.387 0 505.234C0 516.08 4.225 526.28 11.8953 533.949L266.062 788.116C273.981 796.034 284.378 799.991 294.778 799.991C305.178 799.991 315.578 796.032 323.494 788.116L702.856 408.755C720.97 390.64 730.947 366.555 730.947 340.935V151.149C730.947 145.548 730.38 140.079 729.305 134.79C756.728 115.92 776.859 100.134 783.881 93.1117C794.216 82.7805 799.939 69.068 800 54.5008ZM705.027 340.935C705.027 359.63 697.745 377.207 684.528 390.424L305.166 769.788C299.441 775.515 290.119 775.515 284.392 769.788L30.225 515.621C27.4516 512.848 25.9219 509.159 25.9219 505.234C25.9219 501.309 27.45 497.621 30.225 494.848L409.586 115.487C422.806 102.268 440.381 94.9883 459.075 94.9883H648.861C670.173 94.9883 688.752 106.921 698.264 124.455C682.955 134.593 665.812 145.373 647.627 155.973C647.059 155.351 646.48 154.735 645.878 154.134C624.653 132.909 590.119 132.909 568.894 154.134C547.669 175.359 547.669 209.893 568.894 231.118C579.506 241.73 593.447 247.035 607.386 247.035C621.325 247.035 635.266 241.73 645.878 231.118C660.045 216.951 664.741 196.859 659.997 178.748C675.814 169.54 691.003 160.129 705.02 151.024C705.022 151.068 705.025 151.109 705.025 151.151V340.935H705.027ZM595.811 198.449C598.088 202.976 602.656 205.588 607.4 205.588C609.358 205.588 611.347 205.143 613.216 204.202C620.813 200.38 628.383 196.405 635.878 192.334C635.953 199.732 633.188 207.154 627.553 212.788C616.434 223.905 598.347 223.905 587.228 212.788C576.111 201.67 576.111 183.582 587.228 172.463C592.787 166.904 600.089 164.126 607.391 164.126C613.172 164.126 618.936 165.898 623.853 169.38C616.517 173.368 609.072 177.273 601.567 181.049C595.169 184.263 592.592 192.055 595.811 198.449Z" fill="black" />
            <path d="M386.191 264.004C379.033 264.004 373.23 269.805 373.23 276.965V550.682C373.23 557.84 379.033 563.643 386.191 563.643C393.348 563.643 399.152 557.84 399.152 550.682V276.965C399.152 269.805 393.348 264.004 386.191 264.004Z" fill="black" />
            <path d="M326.923 375.333C305.7 354.105 271.164 354.106 249.942 375.331C228.717 396.556 228.717 431.091 249.942 452.316C260.556 462.93 274.494 468.234 288.434 468.233C302.372 468.233 316.314 462.925 326.925 452.316C337.208 442.033 342.87 428.364 342.87 413.823C342.87 399.283 337.206 385.612 326.923 375.333ZM308.595 433.984C297.477 445.103 279.389 445.102 268.272 433.984C257.155 422.866 257.155 404.778 268.272 393.659C273.831 388.1 281.133 385.322 288.434 385.322C295.736 385.322 303.038 388.1 308.597 393.659C313.983 399.045 316.948 406.205 316.948 413.822C316.947 421.439 313.981 428.598 308.595 433.984Z" fill="black" />
            <path d="M522.438 375.331C501.213 354.105 466.677 354.106 445.456 375.331C424.231 396.556 424.231 431.091 445.456 452.316C456.069 462.928 470.008 468.233 483.949 468.233C497.888 468.233 511.828 462.928 522.439 452.316C543.663 431.091 543.663 396.556 522.438 375.331ZM504.108 433.985C492.989 445.103 474.902 445.102 463.784 433.985C452.667 422.866 452.667 404.778 463.784 393.66C469.344 388.1 476.645 385.322 483.947 385.322C491.249 385.322 498.55 388.1 504.109 393.66C515.227 404.778 515.227 422.866 504.108 433.985Z" fill="black" />
          </svg>
          View Discount
        </div>
      </div>
    </div>
  </div>
  <div class="my-shop-info__body">
    <div *ngIf="selShopMenu == 'profile'">
      <div class="my-input" *ngIf="!enableMemberShop">
        <label>Shop Template</label>
        <select class="form-control" [(ngModel)]="shopTemplate">
          <option value="default" selected>Default</option>
          <option value="floral">Floral Pink</option>
          <option value="techno">Techno Blue</option>
        </select>
      </div>
      <div class="my-input">
        <label>Postal Code</label>
        <input type="text" class="form-control" [(ngModel)]="postalCode" minlength="6" maxlength="6" (ngModelChange)="getRegionNameByPostal()" />
      </div>
      <div class="my-input">
        <label>Region</label>
        <input type="text" class="form-control" disabled="disabled" [(ngModel)]="postalCodeRegionName" />
      </div>
      <div class="my-input">
        <label>Profile Link</label>
        <input type="text" class="form-control" placeholder="Profile Link" readonly [(ngModel)]="store_link" />
        <button class="btn btn-sm btn-primary" *ngIf="!store_link" (click)="referFriendLink()">Generate</button>
      </div>
      <div class="my-input">
        <label>Whatsapp Number</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text" style="padding: 2px 8px">+65</div>
          </div>
          <input type="text" class="form-control" placeholder="WhatsApp Number" [(ngModel)]="w_phone_number" name="w_phone_number" pattern="[0-9]*" minlength="8" maxlength="8" (keypress)="validateNumberInput($event)" />
        </div>
      </div>
      <div class="my-input">
        <label>QR Code</label>
        <input type="text" class="form-control" placeholder="Pay Now Text Above QR Code" [(ngModel)]="qr_text" />
      </div>
      <div class="my-input">
        <label>Website</label>
        <input type="text" class="form-control" placeholder="Enter Website" [(ngModel)]="website" />
      </div>
      <div class="my-input">
        <label>Address</label>
        <textarea type="text" class="form-control" row="3" placeholder="Enter Address" [(ngModel)]="address"></textarea>
      </div>
      <div class="my-input">
        <label>Telegram</label>
        <input type="text" class="form-control" placeholder="Enter Telegram" [(ngModel)]="telegram" />
      </div>
      <div class="my-input">
        <label>Shop Category</label>
        <select class="form-control" [(ngModel)]="bizCategory">
          <option *ngIf="!bizCategory" value="" disabled>Select Category Of Your Shop</option>
          <option *ngFor="let category of shopCategories" [value]="category.name">{{ category.name }}</option>
        </select>
      </div>
      <div class="my-checkbox">
        <input [class.blue]="!enableMemberShop" id="buyerContact" type="checkbox" name="buyerContact" [(ngModel)]="buyerContact" />
        <label for="buyerContact"> Don't let buyer text u directly </label>
      </div>
    </div>
    <div *ngIf="selShopMenu == 'seller-info'">
      <!-- reviews/social/seller-info Tab -->
      <ul class="nav nav-tabs mb-2">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: selMenu == 'reviews' }" (click)="selectMenu('reviews')">Reviews</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: selMenu == 'social' }" (click)="selectMenu('social')">Social</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: selMenu == 'seller-info' }" (click)="selectMenu('seller-info')">Seller Info</a>
        </li>
      </ul>
      <form [formGroup]="shopForm">
        <section *ngIf="selMenu == 'reviews'">
          <!-- Google -->
          <div class="my-input">
            <label for="rating">Google Review</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" formControlName="googleReviewUrl" id="rating" aria-describedby="emailHelp" placeholder="Enter Google URL" />
            </div>
          </div>
          <div class="my-input">
            <label for="rating">Google Rating / Count</label>
            <div class="d-flex" style="gap: 5px">
              <input type="text" class="form-control" formControlName="googleReviewRating" id="rating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
              <input type="text" class="form-control" formControlName="googleReviewCount" id="rating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
            </div>
          </div>
          <!-- Google -->
          <!-- Carousell -->
          <div class="my-input">
            <label for="rating">Carousell Review</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" id="rating" formControlName="carousellReviewUrl" aria-describedby="emailHelp" placeholder="Enter Carousell URL" />
            </div>
          </div>
          <div class="my-input">
            <label for="rating">Carousell Rating / Count</label>
            <div class="d-flex" style="gap: 5px">
              <input type="text" class="form-control" id="rating" formControlName="carousellReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
              <input type="text" class="form-control" id="rating" formControlName="carousellReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
            </div>
          </div>
          <!-- Carousell -->
          <!-- FB -->
          <div class="my-input">
            <label for="rating">FB Review</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" id="rating" formControlName="fbReviewUrl" aria-describedby="emailHelp" placeholder="Enter FB URL" />
            </div>
          </div>
          <div class="my-input">
            <label for="rating">FB Rating / Count</label>
            <div class="d-flex" style="gap: 5px">
              <input type="text" class="form-control" id="rating" formControlName="fbReviewRating" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Rating ★ ★" />
              <input type="text" class="form-control" id="rating" formControlName="fbReviewCount" style="background-color: #e9e0e038" aria-describedby="emailHelp" placeholder="Enter Total Count" />
            </div>
          </div>
          <!-- FB -->
        </section>
        <section *ngIf="selMenu == 'social'">
          <div class="my-input">
            <label for="rating">Website</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" id="rating" formControlName="websiteUrl" aria-describedby="emailHelp" placeholder="Enter Website URL" />
            </div>
          </div>
          <div class="my-input">
            <label for="rating">Facebook</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" id="rating" formControlName="fbUrl" aria-describedby="emailHelp" placeholder="Enter Facebook URL" />
            </div>
          </div>
          <div class="my-input">
            <label for="rating">Instagram</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" style="padding: 2px 8px">https://</div>
              </div>
              <input type="text" class="form-control" id="rating" formControlName="instagramUrl" aria-describedby="emailHelp" placeholder="Enter Instagram URL" />
            </div>
          </div>
        </section>
        <section *ngIf="selMenu == 'seller-info'">
          <textarea class="form-control" formControlName="sellerInfo" rows="8" placeholder></textarea>
        </section>
      </form>
      <!-- reviews/social/seller-info Tab -->
    </div>
    <div class="footer-buttons">
      <button class="my-button error" (click)="modal.dismiss('Cross click')">Cancel</button>
      <button class="my-button" [class.blue]="!enableMemberShop" (click)="save_shop_profile()">Save Changes</button>
    </div>
  </div>
</ng-template>

<!-- add review modal -->

<ng-template #add_review_modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Feedback</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body text-center">
    <di class="modal-body-container">
      <form (submit)="saveProductReview()" class="mt-n1">
        <div class="row" style="padding-top: 14px">
          <div class="col-md-12">
            <div class="nm_contact d-flex justify-content-center">
              <div class="form-group">
                <div class="d-flex justify-content-center">
                  <div class="img-circle d-flex justify-content-center align-items-center pointer" (click)="openSelectImageDialog('#user-profile')">
                    <img loading="lazy" *ngIf="!imgBase64" src="../../../../assets/images/uploadd3.png" class="food_img" />
                    <img loading="lazy" *ngIf="imgBase64" width="100%" height="100%" class="user-profile" [src]="imgBase64" alt srcset />
                    <input type="file" id="user-profile" (change)="saveSeletedImage($event)" class="d-none" accept="image/*" />
                  </div>
                </div>
                <div class="mt-4 row">
                  <label for="name" class="col-sm-3 col-form-label">User Name</label>
                  <div class="col-sm-12">
                    <input [(ngModel)]="productReview.userName" type="text" placeholder="Enter user name" class="form-control" id="user_name" name="user_name" />
                  </div>
                </div>
                <div class="mb-3 row">
                  <label for="comment" class="col-sm-1 col-form-label">Comment</label>
                  <div class="col-sm-12">
                    <textarea placeholder="Enter Comment" [(ngModel)]="productReview.comment" id="comment" name="comment" class="form-control"></textarea>
                  </div>
                </div>

                <div class="mb-3 row">
                  <label for="rating" class="col-sm-1 col-form-label">Rating</label>
                  <div class="col-sm-12">
                    <input [(ngModel)]="productReview.rating" type="number" placeholder="Enter rating (0 - 5)" class="form-control" id="rating" min="0" max="5" name="rating" (input)="checkRating($event)" />
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="com_btn add-review-btn px-2" type="submit">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- <img loading="lazy"
        [src]="getImagePath(currentItem.image)"
        class="modal_sm_img"
        alt=""
      /> -->
    </di>
  </div>
</ng-template>

<ng-template #AddMemberShop let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="shopMember">
        <div class="upload-image">
          <input type="file" #upload (change)="saveProductCharSelectedImage($event)" accept="image/*" />
          @if (imageBase64 || selectedMember?.image) {
            @if (imageBase64) {
              <img loading="lazy" [src]="imageBase64" alt="Thumbnail Preview" />
            } @else {
              <img loading="lazy" [src]="imgUrl + selectedMember?.image" />
            }
          } @else {
            <div>
              <svg viewBox="0 0 700 662" fill="none">
                <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z" fill="var(--primary)" />
                <path d="M699.844 353.203C699.844 441.953 627.891 513.984 539.141 514.062H411.563V479.688H539.141C572.891 479.688 604.609 466.484 628.438 442.656C652.344 418.75 665.469 387.031 665.469 353.203C665.469 319.453 652.344 287.656 628.438 263.828C604.531 240 572.734 226.797 538.984 226.797C530 226.797 521.172 227.734 512.578 229.531C500.859 232.031 489.609 236.094 479.141 241.797C478.359 229.766 476.562 217.813 473.828 206.172V206.094C471.016 193.906 467.109 182.031 462.188 170.391C450.938 143.906 434.922 120.078 414.453 99.6094C393.984 79.1406 370.234 63.125 343.672 51.875C316.25 40.3125 287.109 34.375 257.031 34.375C226.953 34.375 197.813 40.2344 170.391 51.875C143.906 63.0469 120.078 79.1406 99.6094 99.6094C79.1406 120.078 63.125 143.906 51.875 170.391C40.2344 197.812 34.375 226.953 34.375 257.031C34.375 287.109 40.2344 316.25 51.875 343.672C63.0469 370.156 79.1406 393.984 99.6094 414.453C120.078 434.922 143.906 450.937 170.391 462.187C197.813 473.75 226.953 479.688 257.031 479.688H288.047V514.062H256.016C114.531 513.516 0 398.672 0 257.031C0 115.078 115.078 0 257.031 0C377.813 0 479.141 83.2813 506.641 195.547V195.625C517.109 193.516 527.891 192.344 538.984 192.344C627.813 192.422 699.844 264.375 699.844 353.203Z" fill="#39393A" />
                <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z" fill="var(--primary)" />
              </svg>
              <!-- <div [class.error]="submitted && bannerControl.banner.errors && bannerControl.banner.errors.required">Please select a banner to upload.</div> -->
            </div>
          }
        </div>
        <div class="all-progress" [class.active]="uploadProgress > 0">
          <p>Uploading... {{ uploadProgress }}%</p>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
          </div>
        </div>

        <!-- <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64" alt="" />
        <img loading="lazy" *ngIf="selectedMember?.image" class="mt-2 product-char-image" [src]="imgUrl + selectedMember?.image" />

        <button class="com_btn px-1 month-list-add-more mt-3" style="background-color: #0404085c" (click)="upload.click()"><i class="fas fa-plus"></i> Upload Member Image</button>
        <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none" accept="image/*" /> -->

        <div class="form-group">
          <label class="mb-0">Title </label>
          <input type="text" rows="3" placeholder="Enter Employee Name" class="form-control" formControlName="title" />
        </div>

        <div class="form-group">
          <label for="exampleInputEmail1" class="mb-0">Description</label>
          <textarea type="text" formControlName="description" class="form-control" row="6" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Description"></textarea>
        </div>

        <section class="grid-member" *ngIf="memberList && memberList.length > 0">
          <div class="grid-member__card" *ngFor="let m of memberList">
            <img loading="lazy" [src]="imgUrl + m?.image" (error)="commonService.handleErrorUpload($event)" />
            <div class="grid-member__card--title">{{ m?.title }}</div>
            <div class="grid-member__card--action">
              <div class="icon" (click)="addMember(m, AddMemberShop)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </div>
              <div class="icon" (click)="deleteShopMember(m.id)">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </section>
        <div class="mt-3 text-right">
          <button class="my-button-3 error" (click)="modalService.dismissAll()">Close</button>
          <button class="my-button-3 mx-2" (click)="addShopMember()"><i class="fa-solid fa-plus"></i> Add New</button>
          <button class="my-button-3" (click)="saveShopMember()"><i class="fa-solid fa-save"></i> Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
